import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";
import { JobLifecycleDTO, MissionControlLog, TraceLogsDTO } from "@domain/MissionControl";
import { env } from "../../config/env";

export class MissionControlAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/mission-control`;
	}

	public async getLogs(user: string, start: string, end: string): Promise<MissionControlLog[]> {
		const url = `${this.baseUrl}/logs`;
		const response = await apiClient.get(url, {
			...StandardAxiosConfig(),
			params: { user, start, end },
		});
		return response.data as MissionControlLog[];
	}

	/** Portal Activity timeline (JobDiagnosticsPanel): Sentry logs/issues + SES emails for a job.
	 *  `refresh: true` bypasses the API's server-side TTL cache and repopulates it. */
	public async getJobLifecycle(recordId: string, opts?: { refresh?: boolean }): Promise<JobLifecycleDTO> {
		const url = `${this.baseUrl}/jobs/${recordId}/lifecycle`;
		const response = await apiClient.get(url, {
			...StandardAxiosConfig(),
			...(opts?.refresh ? { params: { refresh: 1 } } : {}),
		});
		return response.data as JobLifecycleDTO;
	}

	/** Lazy trace drill-down for a single log row in the Activity timeline.
	 *  `refresh: true` bypasses the API's server-side TTL cache and repopulates it. */
	public async getTraceLogs(traceId: string, opts?: { refresh?: boolean }): Promise<TraceLogsDTO> {
		const url = `${this.baseUrl}/jobs/trace/${traceId}/logs`;
		const response = await apiClient.get(url, {
			...StandardAxiosConfig(),
			...(opts?.refresh ? { params: { refresh: 1 } } : {}),
		});
		return response.data as TraceLogsDTO;
	}
}
